export default "__VITE_ASSET__f7d59369__"